// Convert integer/decimal amount to Spanish (Dominican) words.
// Examples:
//   90000 -> "NOVENTA MIL PESOS DOMINICANOS"
//   45000.50 -> "CUARENTA Y CINCO MIL PESOS DOMINICANOS CON 50/100"
//   1500 -> "MIL QUINIENTOS PESOS DOMINICANOS"

const UNIDADES = ["", "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"];
const DIEZ_A_VEINTE = ["DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO", "DIECINUEVE"];
const DECENAS = ["", "", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"];
const CENTENAS = ["", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"];

function lessThan100(n) {
  if (n === 0) return "";
  if (n < 10) return UNIDADES[n];
  if (n < 20) return DIEZ_A_VEINTE[n - 10];
  if (n < 30) {
    const u = n - 20;
    return u === 0 ? "VEINTE" : "VEINTI" + UNIDADES[u].toLowerCase().toUpperCase().replace("UNO", "UNO");
  }
  const d = Math.floor(n / 10);
  const u = n % 10;
  if (u === 0) return DECENAS[d];
  return DECENAS[d] + " Y " + UNIDADES[u];
}

function lessThan1000(n) {
  if (n === 0) return "";
  if (n === 100) return "CIEN";
  const c = Math.floor(n / 100);
  const rest = n % 100;
  const cText = c === 0 ? "" : CENTENAS[c];
  const restText = lessThan100(rest);
  return (cText + (cText && restText ? " " : "") + restText).trim();
}

function integerToWords(n) {
  if (n === 0) return "CERO";
  const millones = Math.floor(n / 1_000_000);
  const restMil = n % 1_000_000;
  const miles = Math.floor(restMil / 1000);
  const rest = restMil % 1000;
  let parts = [];
  if (millones > 0) {
    if (millones === 1) parts.push("UN MILLÓN");
    else parts.push(lessThan1000(millones) + " MILLONES");
  }
  if (miles > 0) {
    if (miles === 1) parts.push("MIL");
    else parts.push(lessThan1000(miles) + " MIL");
  }
  if (rest > 0) parts.push(lessThan1000(rest));
  return parts.join(" ").trim();
}

export function numberToSpanishPesos(amountStr) {
  if (!amountStr) return "";
  const clean = String(amountStr).replace(/,/g, "").replace(/\s/g, "");
  const num = parseFloat(clean);
  if (!Number.isFinite(num) || num < 0) return "";
  const entero = Math.floor(num);
  const decimal = Math.round((num - entero) * 100);
  let words = integerToWords(entero) + " PESOS DOMINICANOS";
  if (decimal > 0) {
    words += ` CON ${String(decimal).padStart(2, "0")}/100`;
  }
  return words;
}
